import React from "react";
var __jsx = React.createElement;

/* eslint-disable max-lines */
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { useCallback, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { ImageDialog } from 'components/common/ImageDialog';
import { HoverButton } from 'components/common/material-ui/custom-components';
import { CoverOverrideDialog } from 'components/content/CoverOverrideDialog';
import { useFieldError } from 'libs/content/hooks';
import { EditIcon, HoverButtonContainer, ImageContainer, ImagePlaceholder, Img, MaxSizeInfo, PlusIcon, SizeInfo, TrashIcon } from './CoverDefaultImageInput.style';

var CoverDefaultImageInput = function CoverDefaultImageInput(_ref) {
  var name = _ref.name,
      labelId = _ref.labelId,
      recommendedWidth = _ref.recommendedWidth,
      ratio = _ref.ratio,
      constraints = _ref.constraints,
      defaultValue = _ref.defaultValue,
      setImageConfig = _ref.setImageConfig,
      defaultImageConfig = _ref.defaultImageConfig;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(false),
      isOverrideModalOpen = _useState2[0],
      setIsOverrideModalOpen = _useState2[1];

  var _useState3 = useState(false),
      isHovered = _useState3[0],
      setHover = _useState3[1];

  var _useState4 = useState(false),
      isOverridden = _useState4[0],
      setIsOverridden = _useState4[1];

  var _useState5 = useState(undefined),
      confirmedImageData = _useState5[0],
      setConfirmedImageData = _useState5[1];

  var imageRatio = ratio.width / ratio.height;
  var errorMessage = useFieldError(name);
  var handleModalClose = useCallback(function (imageData, onChange) {
    if ((imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl) === '') {
      setIsOverridden(false);
      onChange({
        imgUrl: undefined,
        legend: '',
        credits: ''
      });
    }

    setIsOpen(false);
  }, []);
  var handleModalConfirm = useCallback(function (imageData, onChange) {
    setConfirmedImageData(imageData);
    setIsOpen(false);

    if (imageData.imgUrl === '' || isEmpty(defaultImageConfig.defaultImageUrl) && imageData !== undefined) {
      setIsOverridden(false);
      onChange(imageData);
      return;
    }

    setIsOverrideModalOpen(true);
  }, [defaultImageConfig.defaultImageUrl]);

  var handleOverrideModal = function handleOverrideModal(override, onChange) {
    setIsOverrideModalOpen(false);
    setIsOverridden(override);

    if (confirmedImageData !== undefined) {
      onChange(confirmedImageData);
    }
  };

  var ImageInputControllerContent = function ImageInputControllerContent(_ref2) {
    var _ref2$field = _ref2.field,
        onChange = _ref2$field.onChange,
        value = _ref2$field.value;
    useEffect(function () {
      setImageConfig({
        reset: isOverridden,
        defaultImageUrl: value.imgUrl === '' ? undefined : value.imgUrl
      });
    }, [value]);
    return __jsx(FormControl, {
      variant: "outlined",
      error: Boolean(errorMessage)
    }, __jsx(ImageContainer, {
      ratio: imageRatio,
      onMouseOver: function onMouseOver() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      }
    }, isEmpty(value === null || value === void 0 ? void 0 : value.imgUrl) ? __jsx(ImagePlaceholder, {
      onClick: function onClick() {
        return setIsOpen(true);
      }
    }, __jsx(PlusIcon, null), __jsx(FormattedMessage, {
      id: "imageInput.placeholder"
    })) : __jsx(React.Fragment, null, __jsx(Img, {
      src: value.imgUrl,
      isHover: isHovered
    }), isHovered && __jsx(HoverButtonContainer, null, __jsx(HoverButton, {
      color: "primary",
      variant: "outlined",
      startIcon: __jsx(EditIcon, null),
      onClick: function onClick() {
        setIsOpen(true);
        setHover(false);
      }
    }, __jsx(FormattedMessage, {
      id: "imageInput.edit"
    })), __jsx(HoverButton, {
      color: "primary",
      variant: "outlined",
      startIcon: __jsx(TrashIcon, null),
      onClick: function onClick() {
        onChange({
          imgUrl: '',
          legend: '',
          credits: ''
        });
        setHover(false);
      }
    }, __jsx(FormattedMessage, {
      id: "imageInput.delete"
    }))))), __jsx(ImageDialog, {
      open: isOpen,
      initialData: value,
      onClose: function onClose() {
        return handleModalClose(value, onChange);
      },
      onConfirm: function onConfirm(imageData) {
        return handleModalConfirm(imageData, onChange);
      },
      imageConstraints: {
        constraints: constraints,
        imageLabelId: labelId
      },
      imageRatio: imageRatio,
      displayAnchor: true
    }), __jsx(CoverOverrideDialog, {
      open: isOverrideModalOpen,
      onClose: function onClose() {
        return handleOverrideModal(false, onChange);
      },
      onConfirmCover: function onConfirmCover() {
        return handleOverrideModal(false, onChange);
      },
      onConfirmAll: function onConfirmAll() {
        return handleOverrideModal(true, onChange);
      }
    }), __jsx(FormHelperText, null, errorMessage));
  };

  return __jsx(React.Fragment, null, __jsx(InputLabel, {
    error: Boolean(errorMessage)
  }, __jsx(FormattedMessage, {
    id: labelId
  }), recommendedWidth !== undefined && __jsx(SizeInfo, null, "(", recommendedWidth, "x", recommendedWidth / imageRatio, ")")), __jsx("div", null, __jsx(MaxSizeInfo, null, __jsx(FormattedMessage, {
    id: "imageInput.constraintLabel",
    values: {
      maxWidth: constraints.maxWidth,
      minWidth: constraints.minWidth,
      ratioWidth: ratio.width,
      ratioHeight: ratio.height
    }
  }))), __jsx(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : {},
    render: ImageInputControllerContent
  }));
};

export default CoverDefaultImageInput;